import { Injectable, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import {
  Subject,
  merge,
  timer,
  fromEvent
} from 'rxjs';
import {
  switchMap,
  takeUntil
} from 'rxjs/operators';
import { LogsService } from './logs.service';
import { UserProfileService } from './user.service';
import { EventosService } from './eventos.service';
import { Decrypt, detectBrowserName } from 'src/app/pages/functions/functions';
import moment from 'moment';
import { AuditService } from './audit.service';
import { AuditLog } from '../models/AuditLog.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { ToastsService } from './toasts.service';

@Injectable({
  providedIn: 'root'
})
export class InactivityService {
  private destroy$ = new Subject<void>();
  private started = false;

  private readonly inactivityTime = 10 * 60 * 1000; // 10 minutos
  // private readonly inactivityTime = 10 * 60 * 1000; // 10 minutos

  constructor(
    private router: Router,
    private logsService: LogsService,
    private usuerService: UserProfileService,
    private eventosService: EventosService,
    private auditService:AuditService,
     private modalService: NgbModal,
     private toastService:ToastsService
  ) {}

get locationId(): string {
      return localStorage.getItem('location') || '';
  }
  
  /**
   * Inicia el detector de inactividad
   */
  startWatching(): void {

  if (this.started) {
    return;
  }

  console.log('🟢 InactivityService iniciado');

  this.started = true;

  this.startInactivityWatcher();

  }

  /**
   * Detiene el detector
   */
  stopWatching(): void {

    if (!this.started) {
      return;
    }

    this.destroy$.next();
    this.destroy$.complete();

    // Se vuelve a crear para un futuro login
    this.destroy$ = new Subject<void>();

    this.started = false;

  }

  private startInactivityWatcher(): void {

    merge(

      timer(0), // Inicia el contador inmediatamente

      fromEvent(document, 'mousemove'),
      fromEvent(document, 'mousedown'),
      fromEvent(document, 'click'),
      fromEvent(document, 'scroll'),
      fromEvent(document, 'keydown'),
      fromEvent(document, 'touchstart')

    )
    .pipe(

      switchMap(() => timer(this.inactivityTime)),
      
      takeUntil(this.destroy$)

    )
    .subscribe(() => {

      this.logoutByInactivity();

    });

  }

  private async logoutByInactivity(): Promise<void> {

    try {
        this.modalService.dismissAll();

        // Cerrar cualquier SweetAlert abierto
        Swal.close();

      const geoip: any = await this.usuerService.geoip;
      const navegador = detectBrowserName();

      const data = {
        user_id: this.usuerService.uid,
        msg: 'Cierre de sesión por inactividad',
        petition: 'POST',
        detail: 'Cierre de sesión por inactividad',
        register_id: this.usuerService.uid,
        navegator: navegador,
        is_login: '0',
        disconnection: '0',
        ip_origin: geoip.ip,
        ipv6: geoip.version,
        ip: geoip.ip,
        network: geoip.connection.domain,
        city: geoip.city,
        latitude: geoip.latitude,
        longitude: geoip.longitude,
        region: geoip.region,
        timezone: geoip.timezone.id,
        postal: geoip.timezone.postal,
        status_id: 4
      };
   
      await this.logsService.postLogs(data);
  
      await this.registrarCierrePorInactividad();

      this.eventosService.bitacora.fechaHoraEvento = new Date();
      this.eventosService.bitacora.usuarioresponsable = 'System';
      this.eventosService.bitacora.tiopevento = '5';
      this.eventosService.bitacora.month = moment().format('YYYY-MM');
      this.eventosService.bitacora.descripcionevento =
        `Cierre de sesión por inactividad ${Decrypt(this.usuerService.usuario.username)}`;
      
      this.toastService.showInfo('Cierre de sesión','Se cerro la sesión por inactividad');
      
      await this.eventosService.registrarEventos();

    } catch (e) {
      console.error(e);
    }

    // Detener el detector
    this.stopWatching();

    // Cerrar sesión
    this.usuerService.logout();

    this.router.navigate(['/locations']);


  }

  ngOnDestroy(): void {

    this.stopWatching();

  }


  private registrarCierrePorInactividad(): void {

  const auditLog: AuditLog = {

    roleName: 'User',

    responsibleUser:
     Decrypt(this.usuerService.usuario.username) ?? 'Unknown',

    actionName: 'LOGOUT',

    moduleName: 'Authentication',

    movement:
      'Cierre de sesión automático por inactividad',

    urlEndpoint:
      this.router.url,

    statusName: 'SUCCESS',

    createdBy:
     Decrypt(this.usuerService.usuario.username) ?? 'System',

    previousData: JSON.stringify({
      reason: 'INACTIVITY',
      inactivityTime: '10 minutes'
    }),

    newData: null,

    createdAt: new Date()

  };

  this.auditService.registrar(auditLog);
}




}